import { wixCliAppsFlowTunnelCreationStatusSrc11Evid5233 } from '@wix/bi-logger-dev-tools-data/v2';
import type { BiLogger } from '@wix/cli-telemetry';

export const wixCliTunnelBiEvents = (biLogger: BiLogger) => ({
  tunnel: () => {
    const startTimestamp = Date.now();
    return {
      finish: ({
        isSuccess,
        failureReason,
      }: {
        isSuccess: boolean;
        failureReason?: string;
      }) => {
        void biLogger.report(
          wixCliAppsFlowTunnelCreationStatusSrc11Evid5233({
            isSuccess,
            failureReason,
            tunnelCreationTime: Date.now() - startTimestamp,
          })
        );
      },
    };
  },
});
